// Classifies a convention relative to `now`: future, ongoing, or past.
// Pure function — no stores, no JSX.
//
// Every mutually exclusive flag is set EXPLICITLY (false included) in every
// branch: view.js merges the result into component state on each reload, and a
// page left open across the start/end boundary must have its old flags cleared
// by the merge. Omitting a `false` here re-introduces the latched-flag bug
// where isInTheFuture stayed true after the convention started and focus mode
// never activated for shooters who opened the page early.
//
// `isStarted` is intentionally NOT set in the past branch (kept as-is by the
// merge) to preserve the existing view behavior.
export function resolveConventionTimeState(convention, now = new Date()) {
    const from = new Date(convention.startDate);
    const to = new Date(convention.endDate);
    const registrationFrom = new Date(convention.registrationStartDate || convention.startDate);
    registrationFrom.setHours(registrationFrom.getHours() - 1);

    if (from < now && to > now) {
        return {
            isOngoing: true,
            isInTheFuture: false,
            isInThePast: false,
            isStarted: true,
            isValidDate: true,
            isRegistrationOpen: registrationFrom < now && to > now,
            registrationFrom,
        };
    }
    if (from > now) {
        return {
            isOngoing: false,
            isInTheFuture: true,
            isInThePast: false,
            isStarted: false,
            isValidDate: false,
            isRegistrationOpen: registrationFrom < now && to > now,
            registrationFrom,
        };
    }
    return {
        isOngoing: false,
        isInTheFuture: false,
        isInThePast: true,
        isValidDate: false,
        isRegistrationOpen: false,
        registrationFrom,
    };
}
